var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Header'),_c('Product'),_c('News'),_c('About')],1)}
var staticRenderFns = []

export { render, staticRenderFns }